"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PasswordMaskIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M23,12A11.817,11.817,0,0,0,1,12a11.881,11.881,0,0,0,4.413,5.486L3.558,20.637l1.465.862,1.864-3.166a11.729,11.729,0,0,0,4.577,1.146v4.036h1.7V19.437a11.72,11.72,0,0,0,4.43-1.354L19.605,21.5l1.465-.862-2.041-3.468A11.882,11.882,0,0,0,23,12Z" })));
}
exports.default = PasswordMaskIcon;
